import { IRequest } from '@r1-frontend/shared/types/IRequest';


export interface ICheckResponse {
    sum: number,
    type: number,
    expireDate?: string,
}

export enum ErrorCodeStatus {
    PROMOCODE_NOT_FOUND = 'PROMOCODE_NOT_FOUND',
    UNKNOWN = 'UNKNOWN'
}

/*
* Проверка доступности промокода для неавторизованного пользователя
* https://master.api-loyalty.sandbox.d2c.r-one.io/docs/v1#/Promocode/7eddd66cd85b641c15598f640c8c4250
* */
export const check = (providerId: number, promoCode: string): IRequest => ({
    uri: '/v1/unauth-promocode/check',
    method: 'GET',
    headers: { providerId: `${providerId}` },
    queryParams: { promocodeName: promoCode },
});
